export default {
  whoWeAreLine1: {
    id: 'home_who_we_are_line1',
    defaultMessage: 'Back Market is a marketplace that fights',
  },
  whoWeAreLine2: {
    id: 'home_who_we_are_line2',
    defaultMessage: 'against planned obsolescence.',
  },
  whoWeAreLink: {
    id: 'home_who_we_are_link',
    defaultMessage: 'Learn more',
  },
  whoWeAreLinkTitle: {
    id: 'home_who_we_are_link_title',
    defaultMessage: 'about Back Market',
  },
}
